/**
 * Who is really at the keyboard, for the Issue Center.
 *
 * Under impersonation the website's `user` is the impersonated account (`user.id` and `user.permissions` are
 * theirs) and `impersonated_by_admin_id` is the real admin. A card filed or a comment posted then belongs to the
 * admin: the database enforces it (fn_site_issue_set_lodger, fn_site_issue_comment_set_author), and the website
 * sends the same thing so what it shows matches what is stored.
 */

interface IssueCenterUser {
    id: string;
    email?: string | null;
    is_platform_admin?: boolean;
    impersonated_by_admin_id?: string | null;
}

/** The real person's id: the admin while impersonating, else the signed-in user. */
export function realUserId(user: IssueCenterUser | null | undefined): string | null {
    if (!user) return null;
    return user.impersonated_by_admin_id || user.id;
}

/**
 * Internal staff, as the database decides it (profiles.is_platform_admin), not `platform:view_all`, which 4 of
 * the 11 admins do not hold. Someone impersonating is always staff: only admins can impersonate.
 */
export function isStaffUser(user: IssueCenterUser | null | undefined): boolean {
    if (!user) return false;
    return user.is_platform_admin === true || !!user.impersonated_by_admin_id;
}

/** The account whose view a fault is being reported from, when it is not the real person's own. */
export function seenAsUserId(user: IssueCenterUser | null | undefined): string | null {
    if (!user?.impersonated_by_admin_id) return null;
    return user.id;
}
